import { Show } from '@chakra-ui/react';
import { NestedHome } from '@habity/types';
import { HomeProfileHero } from '../Hero';
import { HomeProfileFooter } from '../Footer';
import { Page } from '~/components/ui/page/page';
import { HomeProfileContent } from '../Content';

interface ProfilePageProps {
  home: NestedHome;
  relatedHomes: NestedHome[];
  relatedHomesLoading: boolean;
  hasMore: boolean;
  loadMore: () => void;
  onOpenViewingModal?: (viewingId?: number) => void;
}

export const ProfilePage = ({
  home,
  relatedHomes,
  relatedHomesLoading,
  hasMore,
  loadMore,
  onOpenViewingModal,
}: ProfilePageProps) => {
  return (
    <Page>
      <HomeProfileHero home={home} />
      <HomeProfileContent
        home={home}
        relatedHomes={relatedHomes}
        relatedHomesLoading={relatedHomesLoading}
        hasMore={hasMore}
        loadMore={loadMore}
        onOpenViewingModal={onOpenViewingModal}
      />

      {/* Mobile: footer */}
      <Show below="desktop">
        <HomeProfileFooter home={home} />
      </Show>
    </Page>
  );
};
